/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard} from '../../../../../../../../../../_metronic/helpers'
import {SelectModel, PointModel, InfoLaundryBatchDetail} from '../../../../../../model'
import {getLaundryBatchById, getPoint} from '../../../../../../services'
import {
  InputDateWrapper,
  InputTextWrapper,
  SelectWrapper,
} from '../../../../../../../../components/UI/Form/Input'
import {useForm, FormProvider} from 'react-hook-form'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {useCamp, useClient, useCompany, useSite} from '../../../../../../../central/hooks'
import {formatDate} from '../../../../../../../../util/dates'
const TableInformation: FC = () => {
  const {data, setData, loading, setLoading} = useKTable()
  const {currentTabItem} = useLavanderia()
  const methods = useForm<any>({
    // resolver: yupResolver(schemaOrderLaundryWash),
  })
  const [point, setPoint] = useState<SelectModel[]>([])
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])

  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()

  const {setValue, watch} = methods

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    setCompany(response)
  }

  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    setClients(response)
  }

  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    setSites(response)
  }

  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    setCamps(response)
  }

  const getLaundryByIdList = async () => {
    const response = await getLaundryBatchById(currentTabItem.idToEdit, currentTabItem.typeWash)
    const data = response.data.data
    setValue('companiaId', data.companiaId)
    getClientList(data.companiaId as any)
    setValue('clienteId', data.clienteId)
    getSiteList(data.clienteId as any)
    setValue('siteId', data.siteId)
    getCampList(data.siteId as any)
    setValue('campamentoId', data.campamentoId)
    getPointList(data.siteId, data.companiaId, data.clienteId, data.campamentoId)
    setValue('puntoId', data.puntoId)
    setValue('proveedor', data.proveedor)
    setValue('tipoAdministracion', data.tipoAdministracion)
    setValue('fechaEntregaProveedor', formatDate(data.fechaEntregaProveedor))
    setValue('fechaProgramadaProveedor', formatDate(data.fechaProgramadaProveedor))
    setValue('fechaRealInicio', formatDate(data.fechaRealInicio))
    // const fechaLocal = new Date(valueDep)
    // const formattedDate = fechaLocal.toISOString().slice(0, 10)
    // setValue(fieldName, formattedDate)

    setLoading(false)
    setData(data.detalle)
  }

  const getPointList = async (
    idSite: string = '',
    idCompany: string = '',
    idClient: string = '',
    idCampamento: string = '',
  ) => {
    let obj: PointModel = {
      isCombo: true,
      siteId: idSite,
      companiaId: idCompany,
      clienteId: idClient,
      campamentoId: idCampamento,
    }
    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setPoint(mappedSites)
  }

  useEffect(() => {
    getLaundryByIdList()
    getCompanyList()
  }, [])

  const columns: Column<InfoLaundryBatchDetail>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Empresa Subcontratista' />,
      accessor: 'empresaSubContratista',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro documento' />,
      accessor: 'numeroDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombre completo' />,
      accessor: 'nombreResponsable',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro Orden Lavado' />,
      accessor: 'nroOrden',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro boleta' />,
      accessor: 'nroBoleta',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad de prendas' />,
      accessor: 'cantidadPrendas',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'cantidadKG',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Bolsa' />,
      accessor: 'bolsaCorrelativo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Rotulado' />,
      accessor: 'rotuladoCorrelativo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado Orden' />,
      accessor: 'estadoNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado Observación' />,
      accessor: 'estadoObservacion',
      id: 'estadoObservacion',
      Cell: ({...props}) => ( <>         
        {props.data[props.row.index].estadoObservacion === "OBS" && <div className="alert alert-danger text-center" role="alert">
          OBSERVADA
        </div>}
        {props.data[props.row.index].estadoObservacion === "LIB" && <div className="alert alert-success text-center" role="alert">
          LIBERADA
        </div>}
      </>),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-3'>
                  <SelectWrapper labelText='Compañía' name='companiaId' data={company} disabled />
                </div>
                <div className='mb-2 col-3'>
                  <SelectWrapper labelText='Cliente' name='clienteId' data={clients} disabled />
                </div>
                <div className='mb-2 col-3'>
                  <SelectWrapper labelText='Site' name='siteId' data={sites} disabled />
                </div>
                <div className='mb-2 col-3'>
                  <SelectWrapper labelText='Campamento' name='campamentoId' data={camps} disabled />
                </div>
                <div className='mb-2 col-3'>
                  <InputTextWrapper
                    labelText='Tipo de Administración'
                    name='tipoAdministracion'
                    disabled
                  />
                </div>

                {watch('tipoAdministracion') === 'EXTERNO' && (
                  <>
                    <div className='mb-2 col-3'>
                      <InputTextWrapper labelText='Proveedor' name='proveedor' disabled={true} />
                    </div>
                    <div className='mb-2 col-3'>
                      <InputDateWrapper
                        labelText='Fecha Entrega a Proveedor'
                        name='fechaEntregaProveedor'
                        disabled
                      />
                    </div>
                    <div className='mb-2 col-3'>
                      <InputDateWrapper
                        labelText='Fecha Programada de Devolución'
                        name='fechaProgramadaProveedor'
                        disabled
                      />
                    </div>
                  </>
                )}
                {watch('tipoAdministracion') === 'COMPAÑÍA' && (
                  <>
                    <div className='mb-2 col-3'>
                      <SelectWrapper
                        labelText='Punto de Lavandería'
                        name='puntoId'
                        data={point}
                        disabled
                      />
                    </div>
                    <div className='mb-2 col-3'>
                      <InputDateWrapper
                        labelText='Fecha Inicio Real de Lavado'
                        name='fechaRealInicio'
                        disabled
                      />
                    </div>
                  </>
                )}
              </div>
            </form>
          </FormProvider>
        </div>
        <>
          <KTable data={data} columns={columns as any} showPagination={false} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </>
      </KTCard>
    </>
  )
}

const TableInformationWrapper = () => {
  return (
    <KTableProvider>
      <TableInformation />
    </KTableProvider>
  )
}
export {TableInformationWrapper}
